import React from "react";
import { useMaintenance } from "@/context/MaintenanceContext";

/**
 * Persistent maintenance banner. Stays pinned at the top whenever
 * /api/maintenance-status returns enabled=true. Non-dismissable by design —
 * customers need to know checkout is paused on every page.
 */
export default function MaintenanceBanner() {
  const { enabled, message } = useMaintenance();
  if (!enabled) return null;
  return (
    <div
      className="bg-[#FFD400] text-black px-6 md:px-12 py-3 border-b-2 border-black/80"
      data-testid="maintenance-banner"
      role="status"
      aria-live="polite"
    >
      <div className="max-w-[1280px] mx-auto flex items-start gap-4">
        <span
          className="label-eyebrow text-black/80 shrink-0"
          style={{ letterSpacing: "0.22em" }}
        >
          Browse-only mode
        </span>
        <span className="text-sm md:text-base leading-snug flex-1">{message}</span>
      </div>
    </div>
  );
}
